<section class="previs-and-production section section__bg-gradient-parent">
  <div
    class="previs-and-production__gradient section__bg-gradient gradient-top"
    aria-hidden="true"
  ></div>
  <div
    class="previs-and-production__gradient section__bg-gradient gradient-bottom"
    aria-hidden="true"
  ></div>

  <div class="previs-and-production__inner container">
    <div class="previs-and-production__expandable-cards">
      <app-hover-expandable-cards [cards]="expandableCards" />
    </div>

    <div class="previs-and-production__content">
      <h2 class="previs-and-production__title title">Built on EVRN</h2>

      <app-youtube-player
        aspectRation="2 / 1"
        videoUrl="https://www.youtube.com/watch?v=vQ5-KVSQLg0"
      />
    </div>
  </div>
</section>
